//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyBtnReturn from '@/components/subComponents/MyBtnReturn'
import axios from 'axios'
import qs from 'qs'
import {
  apiUrl,
  apiParams
} from "@/const/const";

export default {
  name: "feeMaintain",
  components: {
    MyBtnReturn
  },
  data() {
    return {

      ladingId: null,

      bookingId: null,
      feeType: [],

      feeList: [],

      isShowTable: false,
      isShowLoading: false,
    }
  },
  created() {
    document.title = '费用维护';
    this.ladingId = this.$route.query.ladingId;
    this.bookingId = this.$route.query.bookingId;
    this.loadFeeType();
    this.loadFeeList()
  },
  methods: {
    /**
     * 获取费用名称
     */
    loadFeeType() {
      let data = {
        openId: apiParams.openId,
        companyId: apiParams.companyId
      };
      this.$http.post(apiUrl.getFeeIdList, data)
        .then((response) => {
          if (response.data.code == 200) {
            this.feeType = [response.data.data]
          }
        })
        .catch((error) => {
          console.error(error)
        });
    },
    /**
     * 获取费用列表
     */
    loadFeeList() {
      this.isShowLoading = true;
      let data = {
        openId: apiParams.openId,
        companyId: apiParams.companyId,
        bookingId: this.bookingId
      };
      this.$http.post(apiUrl.getFeeDetail, data)
        .then((response) => {
          this.isShowLoading = false;
          if (response.data.code == 200) {
            let list = response.data.data;
            this.feeList = list.map(item => {
              return {
                key: [item.feeId],
                value: item.price,
                id: item.id
              }
            })
          }
        })
        .catch((error) => {
          this.isShowLoading = false;
          console.error(error)
        });

    },
    /**
     * 添加费用名称
     */
    addFee() {
      if (this.feeType.length == 0 && this.feeType[0].length == 0) {
        this.loadFeeType();
        return
      }

      let index = 0;
      if (this.feeList.length != 0) {
        let lastIndex = this.feeType[0].indexOf(this.feeList[this.feeList.length - 1].key[0]);
        index = lastIndex >= 0 && lastIndex < this.feeType[0].length - 1 ? lastIndex + 1 : 0;
      }
      let item = {
        key: [this.feeType[0][index]],
        value: null
      };
      this.feeList.push(item)
    },
    /**
     * 费用维护
     */
    feeSave() {

      let par = {
        openId: apiParams.openId,
        companyId: apiParams.companyId
      };
      let url = apiUrl.saveFee + '?' + qs.stringify(par);
      let data = this.feeList.map(item => {
        return {
          feeId: item.key[0],
          totalup: item.value,
          id: item.id || null,
          orderId: this.bookingId
        }
      });

      this.$vux.loading.show({
        text: 'Loading'
      });
      /**
       * requestbody 传递参数未封装
       */
      axios.post(url, data, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(res => {
        this.msg = res.data;
        this.$vux.loading.hide();
        this.showToast(res.data.data);
        if (res.data.code == 200) {
          this.loadFeeList()
        }
      }).catch(err => {
        this.$vux.loading.hide()
      })

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/siji/feeMaintain/FeeMaintain.vue